{
  "name": "Hub",
  "lang": "Russian",
  "ui": {
    "home": "Входящие",
    "about": "О продукте",
    "services": "Возможности",
    "contact": "Связаться",
    "our_services": "Возможности Hub",
    "learn_more": "Подробнее",
    "form_success": "Спасибо! Мы свяжемся с вами.",
    "form_error": "Не удалось отправить. Попробуйте ещё раз.",
    "done_message": "Ваш сайт готов! Опишите, что хотите изменить, и мы всё поправим.",
    "skip_to_content": "Перейти к основному содержимому",
    "menu": "Меню",
    "yes": "Да",
    "no": "Нет"
  },
  "formUrl": "https://readdy.ai/api/form/dbgg3po03l94aq7vdph0",
  "theme": {
    "accent": "teal",
    "mode": "light",
    "style": "modern"
  },
  "nap": {
    "name": "Hub",
    "phone": "(495) 555-0142",
    "generated": {
      "phone": "141ed4db"
    }
  },
  "pages": [
    {
      "kind": "home",
      "path": "/",
      "title": "Hub — единый центр переписки в WhatsApp и Telegram",
      "description": "Hub объединяет диалоги WhatsApp и Telegram в одну ленту для отдела продаж: роли, переназначение, аналитика, боты и API.",
      "types": [
        "navbar",
        "hero",
        "contact",
        "stats",
        "features",
        "showcase",
        "dashboard",
        "inboxapp",
        "contactsapp",
        "companies",
        "deals",
        "tasks",
        "finance",
        "inbox",
        "onboarding",
        "channels",
        "email",
        "widgets",
        "fields",
        "lifecycle",
        "conversations",
        "snippets",
        "tags",
        "aiassist",
        "aiagents",
        "broadcasts",
        "workflows",
        "knowledge",
        "prompts",
        "catalog",
        "contactsimport",
        "dataexport",
        "zoholink",
        "generalsettings",
        "usersettings",
        "teamsettings",
        "reports",
        "settings",
        "cases",
        "steps",
        "testimonials",
        "faq",
        "cta",
        "footer",
        "stickybar"
      ],
      "sections": {
        "settings": {
          "title": "Настройки в одном окне",
          "subtitle": "Настройки рабочего пространства собраны в одном окне: основные параметры и общая информация, роли пользователей и свои поля, команды, приложения, каналы и интеграции. Слева — разделы настроек, справа — содержимое выбранного раздела: каналы показывают пустое состояние и окно добавления, а переключатели, поиск и кнопки работают прямо в макете."
        },
        "reports": {
          "title": "Отчеты в одном окне",
          "subtitle": "Отчеты собирают цифры по всей переписке: жизненный цикл, звонки, беседы, ответы, резолюции, сообщения, контакты, задания, рейтинг сотрудников, пользователи и трансляции. Выберите отчет в списке слева, задайте период и фильтры — обзорный график и таблица пересчитаются, а переключатель демо-данных наполнит пустое рабочее пространство событиями."
        },
        "cases": {
          "items": [
            {
              "metric": "−38%",
              "metricLabel": "времени на переключение",
              "summary": "Продавцы перестали переключаться между WhatsApp и Telegram, а руководитель получил общую картину нагрузки.",
              "tag": "Оптовая торговля",
              "title": "Переписка двух каналов в одном окне"
            },
            {
              "metric": "+27%",
              "metricLabel": "ответов в первый час",
              "summary": "Фильтр «Без ответа» и переназначение диалогов помогли не терять клиентов в пиковые часы.",
              "tag": "Услуги для бизнеса",
              "title": "Никто не остаётся без ответа"
            },
            {
              "metric": "+41%",
              "metricLabel": "заявок обработано",
              "summary": "Бот принимает заявки и передаёт диалог продавцу — клиент получает ответ без паузы.",
              "tag": "Онлайн-школа",
              "title": "Боты и продавцы в одной ленте"
            }
          ],
          "subtitle": "Что меняется после перехода на единые входящие Hub.",
          "title": "Результаты команд продаж"
        },
        "contact": {
          "fields": [
            {
              "label": "Имя",
              "placeholder": "Как к вам обращаться"
            },
            {
              "label": "Рабочая почта",
              "placeholder": "you@company.ru",
              "type": "email"
            },
            {
              "label": "Телефон",
              "placeholder": "+7 900 000-00-00",
              "type": "tel"
            },
            {
              "label": "Размер команды продаж",
              "options": [
                "1–5 человек",
                "6–20 человек",
                "21–50 человек",
                "Больше 50"
              ],
              "placeholder": "Выберите вариант",
              "type": "select"
            }
          ],
          "note": "Ответим в рабочее время и не передаём данные третьим лицам.",
          "phone": "(495) 555-0142",
          "submit": "Запросить демо",
          "subtitle": "Проведём демо и настроим первый номер WhatsApp или Telegram вместе с вами.",
          "title": "Покажем Hub на ваших сценариях"
        },
        "cta": {
          "button": "Попробовать Hub",
          "subtitle": "Подключите WhatsApp и Telegram, настройте роли за один вечер и отвечайте клиентам быстрее.",
          "title": "Соберите все диалоги в одном окне"
        },
        "faq": {
          "items": [
            {
              "answer": "WhatsApp и Telegram. Диалоги обоих каналов собираются в единой ленте, у каждого сообщения виден канал и номер компании, на который написал клиент.",
              "question": "Какие каналы поддерживает Hub?"
            },
            {
              "answer": "По QR-коду: откройте WhatsApp → Связанные устройства → Сканируйте. Для Telegram номер добавляется по токену. Статус подключения отображается в таблице номеров.",
              "question": "Как подключается номер WhatsApp?"
            },
            {
              "answer": "Продавец видит и отвечает только в диалогах своих номеров. Руководитель видит все диалоги и номера, переназначает продавцов и смотрит аналитику. Администратор подключает номера, ботов, API-ключи и вебхуки.",
              "question": "Чем отличаются роли продавца, руководителя и администратора?"
            },
            {
              "answer": "Да. В шапке чата есть кнопки «Передать боту» и «Забрать у бота», а в ленте появляется системное событие о передаче. Диалог с ботом помечен бейджем «Бот».",
              "question": "Можно ли передать диалог боту и забрать обратно?"
            },
            {
              "answer": "Нет. Внутренние заметки подсвечиваются жёлтым и видны только сотрудникам, клиенту они не отправляются.",
              "question": "Клиент видит внутренние заметки?"
            },
            {
              "answer": "Можно прикреплять медиа и документы до 2 ГБ с drag & drop и индикатором прогресса загрузки. Фото, видео, голосовые и документы отображаются прямо в ленте.",
              "question": "Какие лимиты на размер файлов?"
            }
          ],
          "title": "Частые вопросы"
        },
        "features": {
          "items": [
            {
              "description": "Диалоги обоих каналов в одной ленте с фильтрами, поиском и статусами ответа.",
              "icon": "📥",
              "title": "Единые входящие"
            },
            {
              "description": "Продавец видит свои номера, руководитель переназначает диалоги и смотрит аналитику.",
              "icon": "👥",
              "title": "Роли и переназначение"
            },
            {
              "description": "Передавайте диалог боту и забирайте обратно в один клик, с отметкой в ленте.",
              "icon": "🤖",
              "title": "Боты и передача диалога"
            },
            {
              "description": "Фото, видео, голосовые и документы до 2 ГБ; заметки клиент не видит.",
              "icon": "📎",
              "title": "Медиа и внутренние заметки"
            },
            {
              "description": "Быстрые ответы на частые вопросы экономят время каждому продавцу.",
              "icon": "⚡",
              "title": "Шаблоны ответов"
            },
            {
              "description": "Контроль лимитов и статусов номеров, ключи API и вебхуки для интеграций.",
              "icon": "📊",
              "title": "Аналитика, номера и API"
            }
          ],
          "layout": "bento",
          "subtitle": "Всё, что нужно отделу продаж для ежедневной работы в мессенджерах.",
          "title": "Возможности Hub"
        },
        "dashboard": {
          "subtitle": "Дашборд — первый экран рабочего пространства: пустое состояние каналов, счётчики этапов жизненного цикла, контакты по вкладкам и нагрузка команды. Включите демо-данные, чтобы увидеть, как окно выглядит с реальными цифрами.",
          "title": "Дашборд в одном окне"
        },
        "contactsapp": {
          "subtitle": "Контакты — общая база клиентов рабочего пространства: папки по этапам жизненного цикла и сегментам, поиск по имени, телефону и почте. Кнопка «Добавить контакт» открывает боковую панель с данными контакта, кодом страны, этапом, тегами и своими полями. Агент видит только своих клиентов.",
          "title": "Контакты в одном окне"
        },
        "inboxapp": {
          "subtitle": "Входящие — рабочий экран приложения: папки по ответственным и этапам жизненного цикла, поиск, сортировка, фильтр «Без ответа» и вкладка звонков. Пока каналы не подключены, окно честно показывает пустое состояние — включите демо-данные в левой колонке, и папки наполнятся диалогами.",
          "title": "Входящие в одном окне"
        },
        "inbox": {
          "subtitle": "Живой макет переписки: переключите диалог, отфильтруйте неотвеченные, отправьте сообщение или передайте чат боту.",
          "title": "Так выглядят диалоги в Hub"
        },
        "onboarding": {
          "subtitle": "Начало работы — чеклист первых шагов: подключить каналы, разобраться в жизненном цикле, настроить AI-агентов и пригласить коллег. Прогресс считается сам, а справа собраны ресурсы на случай, если что-то не получается.",
          "title": "Начало работы в одном окне"
        },
        "channels": {
          "subtitle": "Каталог каналов: выберите мессенджер, почту или звонки. WhatsApp подключается по QR-коду, Telegram — по токену бота, остальные — авторизацией в сервисе.",
          "title": "Подключение каналов в одном окне"
        },
        "email": {
          "subtitle": "Ящик Google Workspace, Gmail, Яндекса или своего сервера — и письма клиентов становятся такими же диалогами, как в WhatsApp и Telegram. Справа видно, какие ящики уже подключены.",
          "title": "Подключение почты"
        },
        "widgets": {
          "subtitle": "Виджеты превращают посетителей сайта в диалоги: клиент выбирает WhatsApp, Telegram или почту, а переписка сразу попадает во входящие. Справа — живое превью — двигайте позицию и текст.",
          "title": "Виджеты для сайта"
        },
        "fields": {
          "subtitle": "Карточка клиента собирается из полей: имя, телефон, почта и любые свои — город, номер договора, сегмент. Задайте тип и видимость, а таблица сразу покажет, что увидят продавцы. Поля можно добавлять, дублировать и скрывать прямо в окне.",
          "title": "Поля контактов в одном окне"
        },
        "lifecycle": {
          "subtitle": "Воронка показывает, на каком этапе продаж находится каждый контакт. Перетащите этапы, назначьте стартовый и выигранный, добавьте потерянные — таблица и воронка сразу перестроятся.",
          "title": "Жизненный цикл в одном окне"
        },
        "conversations": {
          "subtitle": "Автозакрытие по неактивности, заметки и категории при закрытии, оценка тональности клиента. Настройте правила один раз — дальше диалоги закрываются сами и остаются понятными в отчётах.",
          "title": "Диалоги в одном окне"
        },
        "snippets": {
          "subtitle": "Сохранённые ответы с текстом и файлами: одно нажатие «/» в поле ответа — и продавец отправляет готовый текст. Задайте название, короткий ID, тему и вложения, а таблица сразу покажет, что найдут коллеги.",
          "title": "Шаблоны ответов в одном окне"
        },
        "tags": {
          "subtitle": "Теги раскладывают диалоги и входящие по темам: эмодзи, цвет и описание. Список сразу показывает, сколько диалогов уже помечено, а окно создания даёт выбрать эмодзи и цвет и запрещает повторяющиеся названия.",
          "title": "Теги в одном окне"
        },
        "aiassist": {
          "subtitle": "AI Assist отвечает клиентам мгновенно: он читает шаблоны и источники знаний вашей компании и предлагает готовый ответ. Переключатели разрешают или запрещают ответы по общим знаниям модели, а персону можно переписать под тон бренда и сразу проверить в тесте.",
          "title": "AI Assist в одном окне"
        },
        "aiagents": {
          "subtitle": "Агенты искусственного интеллекта берут на себя рутину переписки: отвечают круглосуточно, обновляют этапы и поля контактов и передают сложные диалоги людям. Начните с готового шаблона — администратор, агент продаж или поддержка — либо соберите своего агента с нуля и включите демо-данные, чтобы увидеть его в работе.",
          "title": "AI-агенты в одном окне"
        },
        "workflows": {
          "title": "Рабочие процессы в одном окне",
          "subtitle": "Рабочие процессы автоматизируют рутину: триггер запускает цепочку из сообщений, назначений и заданий. Пока процессов нет, окно показывает пустое состояние со схемой — начните с нуля или откройте галерею шаблонов с категориями, а карточка шаблона покажет преимущества и всю схему шагов."
        },
        "broadcasts": {
          "title": "Рассылки в одном окне",
          "subtitle": "Рассылки отправляют одно сообщение сразу многим клиентам: папки по статусам от черновика до ошибки, таблица и календарь отправок. Пока рассылок нет, окно показывает пустое состояние с антенной — включите демо-данные или создайте черновик кнопкой «Добавить рассылку»."
        },
        "knowledge": {
          "subtitle": "Источники знаний — то, на что опирается AI Assist: прайсы и регламенты документами, страницы сайта ссылками и тексты-инструкции вручную. Пока список пуст, ассистент отвечает только по шаблонам; добавьте источник — и он начнёт отвечать по вашим правилам.",
          "title": "Источники знаний AI в одном окне"
        },
        "prompts": {
          "subtitle": "AI Prompts правят черновик до отправки: меняют тон, исправляют орфографию и пунктуацию, переводят на язык клиента и упрощают длинные формулировки. Встроенные правила включают переключателями, свои создают с инструкцией — и всё это сразу видно в превью диалога.",
          "title": "AI Prompts в одном окне"
        },
        "catalog": {
          "subtitle": "Каталог каналов — витрина провайдеров: мессенджеры, звонки, SMS, почта и онлайн-чат. Переключайте категории, ищите по названию и подключайте нужное: ключ, авторизация или код виджета. Уже подключённые каналы отмечены в карточке.",
          "title": "Каталог каналов в одном окне"
        },
        "contactsimport": {
          "subtitle": "Импорт контактов — массовая загрузка клиентов из CSV: email, телефон, компания и теги. Файл читается прямо в браузере, похожие колонки сопоставляются автоматически, а перед загрузкой видно, сколько контактов добавится и сколько строк будет пропущено.",
          "title": "Импорт контактов в одном окне"
        },
        "dataexport": {
          "subtitle": "Экспорт данных — выгрузка записей рабочего пространства для аналитики: контакты, диалоги, сообщения и неудавшиеся сообщения. Выберите набор, запросите файл — он появится в истории, а статус и скачивание обновятся сами.",
          "title": "Экспорт данных в одном окне"
        },
        "generalsettings": {
          "subtitle": "Общие сведения — настройки всего рабочего пространства: название, тайм-аут неактивности и часовой пояс. Здесь же включается еженедельный дайджест на почту и выбираются его получатели.",
          "title": "Общие сведения в одном окне"
        },
        "usersettings": {
          "subtitle": "Настройки пользователей — участники рабочего пространства и их доступ. Пригласите коллегу по почте, выберите уровень доступа (агент, менеджер, администратор) и при необходимости включите дополнительные ограничения, а затем отзовите или измените доступ в один клик.",
          "title": "Настройки пользователей в одном окне"
        },
        "teamsettings": {
          "subtitle": "Настройки команды — команды группируют сотрудников рабочего пространства. Создайте команду с названием, описанием и участниками, найдите нужную поиском и назначайте ей диалоги и контакты вместо каждого пользователя по отдельности.",
          "title": "Настройки команды в одном окне"
        },
        "footer": {
          "brand": "Hub",
          "links": [
            {
              "href": "#dashboard",
              "label": "Дашборд"
            },
            {
              "href": "#inbox-app",
              "label": "Входящие"
            },
            {
              "href": "#contacts-app",
              "label": "Контакты"
            },
            {
              "href": "#inbox",
              "label": "Диалоги"
            },
            {
              "href": "#features",
              "label": "Возможности"
            },
            {
              "href": "#channels",
              "label": "Каналы"
            },
            {
              "href": "#email",
              "label": "Почта"
            },
            {
              "href": "#contact",
              "label": "Связаться"
            },
            {
              "href": "#widgets",
              "label": "Виджеты"
            },
            {
              "href": "#fields",
              "label": "Поля контактов"
            },
            {
              "href": "#lifecycle",
              "label": "Жизненный цикл"
            },
            {
              "href": "#conversations",
              "label": "Диалоги"
            },
            {
              "href": "#snippets",
              "label": "Шаблоны"
            },
            {
              "href": "#tags",
              "label": "Теги"
            },
            {
              "href": "#ai-assist",
              "label": "AI Assist"
            },
            {
              "href": "#ai-agents",
              "label": "AI-агенты"
            },
            {
              "href": "#ai-knowledge",
              "label": "Источники знаний"
            },
            {
              "href": "#broadcasts",
              "label": "Рассылки"
            },
            {
              "href": "#workflows",
              "label": "Рабочие процессы"
            },
            {
              "href": "#ai-prompts",
              "label": "AI Prompts"
            },
            {
              "href": "#catalog",
              "label": "Каталог каналов"
            },
            {
              "href": "#contacts-import",
              "label": "Импорт контактов"
            },
            {
              "href": "#data-export",
              "label": "Экспорт данных"
            },
            {
              "href": "#general-settings",
              "label": "Общие сведения"
            },
            {
              "href": "#user-settings",
              "label": "Настройки пользователей"
            },
            {
              "href": "#team-settings",
              "label": "Настройки команды"
            },
            {
              "href": "#reports",
              "label": "Отчеты"
            },
            {
              "href": "#settings",
              "label": "Настройки"
            },
            {
              "href": "#onboarding",
              "label": "Начало работы"
            }
          ],
          "tagline": "Единый центр переписки с клиентами в WhatsApp и Telegram для отдела продаж."
        },
        "hero": {
          "eyebrow": "Единый центр переписки",
          "primaryCta": "Запросить демо",
          "secondaryCta": "Смотреть возможности",
          "subtitle": "Hub собирает переписку отдела продаж в единую ленту: фильтры, переназначение, заметки, шаблоны и аналитика. Продавцы отвечают, руководители видят всё, администраторы подключают номера и ботов.",
          "title": "Все диалоги WhatsApp и Telegram — в одном окне"
        },
        "navbar": {
          "brand": "Hub",
          "cta": "Получить демо",
          "links": [
            {
              "href": "#",
              "label": "Входящие"
            },
            {
              "href": "#features",
              "label": "Возможности"
            },
            {
              "href": "#channels",
              "label": "Каналы"
            },
            {
              "href": "#email",
              "label": "Почта"
            },
            {
              "href": "#contact",
              "label": "Связаться"
            }
          ]
        },
        "showcase": {
          "items": [
            {
              "description": "Клиент пишет в WhatsApp или Telegram — диалог сразу попадает в Hub с иконкой канала и номером компании.",
              "icon": "💬",
              "points": [
                "Фильтры и поиск",
                "Статусы доставки и ответа"
              ],
              "title": "Одна лента вместо двух приложений"
            },
            {
              "description": "Руководитель назначает ответственного, продавец получает карточку клиента с историей и тегами.",
              "icon": "🎯",
              "points": [
                "История переназначений",
                "Карточка клиента с CRM"
              ],
              "title": "Диалог всегда закреплён за человеком"
            },
            {
              "description": "Руководитель видит нагрузку и ожидание ответа, администратор — статусы номеров и лимиты.",
              "icon": "📈",
              "points": [
                "Ожидание ответа",
                "Лимиты по номерам"
              ],
              "title": "Контроль без ручных отчётов"
            }
          ],
          "subtitle": "Три опоры, на которых держится ежедневная переписка отдела продаж.",
          "title": "Как устроена работа в Hub"
        },
        "stats": {
          "items": [
            {
              "label": "канала: WhatsApp и Telegram",
              "value": "2"
            },
            {
              "label": "роли: продавец, руководитель, админ",
              "value": "3"
            },
            {
              "label": "максимальный размер файла",
              "value": "2 ГБ"
            },
            {
              "label": "оценка 320 команд продаж",
              "value": "4.9"
            }
          ]
        },
        "steps": {
          "items": [
            {
              "description": "Добавьте WhatsApp по QR-коду или Telegram по токену — за пару минут, без программиста.",
              "title": "Подключите номера"
            },
            {
              "description": "Продавцы видят свои диалоги, руководители — все, администраторы управляют доступами и ключами.",
              "title": "Настройте роли"
            },
            {
              "description": "Диалоги из WhatsApp и Telegram попадают в единую ленту с фильтрами и статусами ответа.",
              "title": "Соберите команду в одном окне"
            },
            {
              "description": "Передавайте диалоги продавцам или боту, оставляйте внутренние заметки и используйте шаблоны.",
              "title": "Отвечайте и переназначайте"
            },
            {
              "description": "Аналитика по номерам, продавцам и времени ответа показывает, где теряются клиенты.",
              "title": "Следите за результатом"
            }
          ],
          "title": "Как начать работу с Hub"
        },
        "stickybar": {
          "button": "Связаться",
          "phone": "(495) 555-0142"
        },
        "testimonials": {
          "items": [
            {
              "name": "Мария Петрова",
              "quote": "Раньше держали WhatsApp в телефонах, а Telegram — в вебе. Теперь вся переписка в одной ленте, и ни один клиент не остаётся без ответа.",
              "role": "руководитель отдела продаж"
            },
            {
              "name": "Алексей Ким",
              "quote": "Переназначение диалогов в один клик — супер. Когда продавец в отпуске, я просто передаю его чаты коллеге.",
              "role": "супервайзер"
            },
            {
              "name": "Ольга Смирнова",
              "quote": "Внутренние заметки и шаблоны ответов экономят нам часы каждый день. Клиенту уходит только нужное.",
              "role": "старший продавец"
            },
            {
              "name": "Дмитрий Волков",
              "quote": "Подключил номера по QR-коду и выдал API-ключи команде разработки за один вечер. Раньше это была неделя согласований.",
              "role": "администратор"
            },
            {
              "name": "Ирина Соколова",
              "quote": "Аналитика по времени ответа сразу показала узкое место. Через месяц доля диалогов без ответа упала вдвое.",
              "role": "директор по продажам"
            }
          ],
          "score": "4.8",
          "summary": "180+ отзывов",
          "title": "Отзывы отделов продаж"
        },
        "companies": {
          "title": "Компании — клиент целиком",
          "subtitle": "Компания и все её люди: закупщик, владелец, бухгалтерия. Рядом — клиенты Zoho Books с выручкой, долгом и последним счётом, чтобы переписка и деньги были в одном окне."
        },
        "finance": {
          "title": "Финансы — кто и сколько должен",
          "subtitle": "Дебиторка по клиентам Zoho Books: долг, просрочка и её срок, старение долга, последняя оплата, продавец. Строка раскрывается в счета и оплаты клиента; из диалога видно новый счёт и поступившую оплату."
        },
        "tasks": {
          "title": "Задачи — мои и команды",
          "subtitle": "Задачи из Zoho CRM и новые из Hub: просроченные, на сегодня, на неделе; к контакту, сделке или компании. Заметки и задачи живут в карточках контакта и сделки."
        },
        "deals": {
          "title": "Сделки — воронка и канбан",
          "subtitle": "Сделки из Zoho CRM и новые из переписки: этапы воронки колонками, сумма и дни на этапе, карточка с клиентом, компанией и историей этапов. Правка в Hub главнее CRM."
        },
        "zoholink": {
          "title": "Zoho CRM и Books в Hub",
          "subtitle": "Компании из Zoho CRM и клиенты Zoho Books связываются с людьми из переписки автоматически. Здесь — то, что правила не смогли связать сами: подтвердите подсказку или выберите компанию."
        }
      },
      "images": {
        "hero": {
          "src": "https://readdy.ai/api/flash-image?query=sales%20team%20using%20a%20unified%20customer%20messaging%20inbox%20on%20desktop%20computers%20in%20a%20modern%20office%2C%20wide%20establishing%20photo%20of%20the%20business%20conveying%20%D0%95%D0%B4%D0%B8%D0%BD%D0%B0%D1%8F%20%D0%BB%D0%B5%D0%BD%D1%82%D0%B0%20%D0%B4%D0%B8%D0%B0%D0%BB%D0%BE%D0%B3%D0%BE%D0%B2%20%D0%B8%D0%B7%20WhatsApp%20%D0%B8%20Telegram%2C%20professional%20photography%2C%20natural%20light%2C%20high%20detail%2C%20no%20text%2C%20no%20watermark%2C%20no%20logos&width=1600&height=900&seq=1&orientation=landscape",
          "alt": "Hub"
        },
        "showcase": {
          "src": "https://readdy.ai/api/flash-image?query=sales%20team%20using%20a%20unified%20customer%20messaging%20inbox%20on%20desktop%20computers%20in%20a%20modern%20office%2C%20photo%20illustrating:%20%D0%9E%D0%B4%D0%BD%D0%B0%20%D0%BB%D0%B5%D0%BD%D1%82%D0%B0%20%D0%B2%D0%BC%D0%B5%D1%81%D1%82%D0%BE%20%D0%B4%D0%B2%D1%83%D1%85%20%D0%BF%D1%80%D0%B8%D0%BB%D0%BE%D0%B6%D0%B5%D0%BD%D0%B8%D0%B9%2C%20professional%20photography%2C%20natural%20light%2C%20high%20detail%2C%20no%20text%2C%20no%20watermark%2C%20no%20logos&width=1000&height=800&seq=2&orientation=landscape",
          "alt": "Одна лента вместо двух приложений"
        },
        "showcase2": {
          "src": "https://readdy.ai/api/flash-image?query=sales%20team%20using%20a%20unified%20customer%20messaging%20inbox%20on%20desktop%20computers%20in%20a%20modern%20office%2C%20photo%20illustrating:%20%D0%94%D0%B8%D0%B0%D0%BB%D0%BE%D0%B3%20%D0%B2%D1%81%D0%B5%D0%B3%D0%B4%D0%B0%20%D0%B7%D0%B0%D0%BA%D1%80%D0%B5%D0%BF%D0%BB%D1%91%D0%BD%20%D0%B7%D0%B0%20%D1%87%D0%B5%D0%BB%D0%BE%D0%B2%D0%B5%D0%BA%D0%BE%D0%BC%2C%20professional%20photography%2C%20natural%20light%2C%20high%20detail%2C%20no%20text%2C%20no%20watermark%2C%20no%20logos&width=1000&height=800&seq=3&orientation=landscape",
          "alt": "Диалог всегда закреплён за человеком"
        },
        "showcase3": {
          "src": "https://readdy.ai/api/flash-image?query=sales%20team%20using%20a%20unified%20customer%20messaging%20inbox%20on%20desktop%20computers%20in%20a%20modern%20office%2C%20photo%20illustrating:%20%D0%9A%D0%BE%D0%BD%D1%82%D1%80%D0%BE%D0%BB%D1%8C%20%D0%B1%D0%B5%D0%B7%20%D1%80%D1%83%D1%87%D0%BD%D1%8B%D1%85%20%D0%BE%D1%82%D1%87%D1%91%D1%82%D0%BE%D0%B2%2C%20professional%20photography%2C%20natural%20light%2C%20high%20detail%2C%20no%20text%2C%20no%20watermark%2C%20no%20logos&width=1000&height=800&seq=4&orientation=landscape",
          "alt": "Контроль без ручных отчётов"
        }
      }
    }
  ]
}
